define('common/tools',['underscore', 'knockout', 'jquery', 'bluebird'], function (_, ko, $, Promise) {

    /**
     * @private
     */
    var prioritySortLow = function(a, b) {
        return b.priority - a.priority;
    };

    /**
     * @private
     */
    var prioritySortHigh = function(a, b) {
        return a.priority - b.priority;
    };

    /**
     * @constructor
     * @class PriorityQueue manages a queue of elements with priorities. Default
     * is highest priority first.
     *
     * @param [options] If low is set to true returns lowest first.
     */
    var PriorityQueue = function(options) {
        var contents = [];

        var sorted = false;
        var sortStyle = (options && options.low) ? prioritySortLow : prioritySortHigh;

        /**
         * @private
         */
        var sort = function() {
            contents.sort(sortStyle);
            sorted = true;
        };

        var self = {
            /**
             * Removes and returns the next element in the queue.
             * @member PriorityQueue
             * @return The next element in the queue. If the queue is empty returns
             * undefined.
             *
             * @see PrioirtyQueue#top
             */
            pop: function() {
                if(!sorted) {
                    sort();
                }

                var element = contents.pop();
                return element ? element.object : undefined;
            },

            peekLast: function() {
                if(!sorted) {
                    sort();
                }

                var element = contents[0];
                return element ? element.object : undefined;
            },

            popLast: function() {
                if(!sorted) {
                    sort();
                }

                var element = contents.shift();
                return element ? element.object : undefined;
            },

            /**
             * Returns but does not remove the next element in the queue.
             * @member PriorityQueue
             * @return The next element in the queue. If the queue is empty returns
             * undefined.
             *
             * @see PriorityQueue#pop
             */
            top: function() {
                if(!sorted) {
                    sort();
                }

                var element = contents[contents.length - 1];
                return element ? element.object : undefined;
            },

            /**
             * @member PriorityQueue
             * @param object The object to check the queue for.
             * @returns true if the object is in the queue, false otherwise.
             */
            includes: function(object) {
                for(var i = contents.length - 1; i >= 0; i--) {
                    if(contents[i].object === object) {
                        return true;
                    }
                }

                return false;
            },

            /**
             * @member PriorityQueue
             * @returns the current number of elements in the queue.
             */
            size: function() {
                return contents.length;
            },

            /**
             * @member PriorityQueue
             * @returns true if the queue is empty, false otherwise.
             */
            empty: function() {
                return contents.length === 0;
            },

            /**
             * @member PriorityQueue
             * @param object The object to be pushed onto the queue.
             * @param priority The priority of the object.
             */
            push: function(object, priority) {
                contents.push({object: object, priority: priority});
                sorted = false;
            }
        };

        return self;
    };

    var WhenVisibleTrigger = function($elementOrSelectorToBeVisible, triggerCallback, retryWaitMS /* defaults to 100 */) {
        var self = this;
        var retryTriggerSubscription;
        retryWaitMS = retryWaitMS || 100;

        self.trigger = _.debounce(function() {
            var waitMS = retryWaitMS;
            var $elementToBeVisible = $elementOrSelectorToBeVisible;
            if(_.isString($elementToBeVisible)) {
                $elementToBeVisible = $($elementToBeVisible);
            }

            //If it has been removed retry slower (it could be removed and forgotten or it may not have been rendered yet)
            if(!$.contains(document.documentElement, $elementToBeVisible[0])) {
                waitMS = retryWaitMS * 10;
            }

            if ($elementToBeVisible.is(':visible')) {
                if(retryTriggerSubscription) {
                    clearTimeout(retryTriggerSubscription);
                    retryTriggerSubscription = undefined;
                }
                triggerCallback.apply(this, arguments);
            } else if (!retryTriggerSubscription) {
                retryTriggerSubscription = setTimeout(function() {
                    retryTriggerSubscription = undefined;
                    self.trigger.apply(this, arguments);
                }, waitMS);
            }
        }, 50);

        self.dispose = function() {
            clearTimeout(retryTriggerSubscription);
        };
    };

    var idCounter = 0;

    var Tools = function() {
        var self = this;

        self.objToHash = function(obj) {

            if (_.isUndefined(obj)) {
                return '?';
            }
            if (_.isNull(obj)) {
                return 'X';
            }
            if(obj.$$uniqueId) {
                return obj.$$uniqueId;
            }
            if (_.isArray(obj)) {
                return '[' + _.reduce(obj, function (memo, param) {
                    return memo + '|' + self.objToHash(param);
                }, '') + ']';
            }
            if(_.isString(obj)) {
                return 'S' + obj;
            }
            if(_.isNumber(obj)) {
                return '#' + obj;
            }
            if(_.isBoolean(obj)) {
                return obj ? 'T' : 'F';
            }

            if (obj === Array) {
                return 'Array';
            }

            var id = obj.$$uniqueId || ++idCounter;
            Object.defineProperty(obj, '$$uniqueId', { enumerable: false, value: id});
            return id;
        };

        self.argumentsToHash = function() { return self.objToHash(_.toArray(arguments)); };

        self.PriorityQueue = PriorityQueue;
        self.WhenVisibleTrigger = WhenVisibleTrigger;
        self.lazyRequire = _.memoize(function(moduleName) {
            var lazyModule = ko.observable();
            require([moduleName], lazyModule);
            return lazyModule;
        });

        self.loadImage = function(imageUrl, timeout) {
            timeout = timeout || 5000;
            var dfd = $.Deferred(),
                img = new Image(),
                timer;

            img.onload = function() {
                clearTimeout(timer);
                dfd.resolve();
            };

            img.onerror = function() {
                clearTimeout(timer);
                dfd.reject('notfound');
            };

            img.src = imageUrl;

            if (timeout > 0) {
                timer = setTimeout(dfd.reject.bind(dfd, 'timeout'), timeout);
            }

            return dfd;
        };

        self.loadImages = function(imageUrlArray, timeout) {
            var promises = _.chain(imageUrlArray).compact().map(function(imageUrl) {
                return self.loadImage(imageUrl, timeout);
            }).value();

            return  $.when.apply($, promises);
        };

        self.getURLParameter = function(name, _location) {
            return decodeURI(
                (new RegExp(name + '=' + '(.+?)(&|$)').exec((_location || location).search)||[,null])[1]
            );
        };

        self.addHook = function(model, methodName, hook, optionalContext) {
            var oldLifeCycleCallback = model[methodName] || function() {};

            model[methodName] = function() {
                oldLifeCycleCallback.apply(model, arguments);
                hook.apply(optionalContext || model, arguments);
            };
        };

        /**
         * Returns an array with num 'copies' of the o param in an array,
         * this does not use clone so object will only duplicate references
         * @param num {int} Number of copies
         * @param o {*} Thing to 'copy'
         * @returns {[*]} Array of things
         */
        self.giveMe = function(num, o) {
            return _.times(num, function() {
                return o;
            });
        };

        /**
         * Greatest Common Factor
         * @return {*} Greatest Common Factor for the arguments applied
         */
        self.gcf = function(a, b) {
            return ( !b ) ? (a):( self.gcf(b, a % b) );
        };

        /**
         * Least Common Mulitple
         * @return {*} Least Common Multiple for the arguments applied
         */
        self.lcm = function() {
            return _.reduce(arguments, function(a, b) {
                return ( a / self.gcf(a,b) ) * b;
            }, 1);
        };

        /**
         * Call any constructor with an array of arguments (like apply on non constructor functions)
         * @param constructor Any constructor except built-in
         * @param args An array of arguments
         * @returns {*} An object instance of the constructor with the passed arguments
         */
        self.construct = function(constructor, args) {
            function F() {
                return constructor.apply(this, args);
            }
            F.prototype = constructor.prototype;
            return new F();
        };

        self.decodeHtml = function(html) {
            return $('<div/>').html(html).text();
        };

        self.postToUrl = function(url, params) {
            var $form = $('<form enctype="application/x-www-form-urlencoded" method="POST" />').attr('action', url);

            _.each(ko.unwrap(params), function (value, name) {
                var input = $('<input type="hidden"/>').attr('name', name).attr('value', value);
                $form.append(input);
            });

            var documentBody = document.body;
            var formNode = documentBody.appendChild($form[0]); // Some browsers require the form to be in the DOM at the time it's submitted

            $form.submit();
            documentBody.removeChild(formNode);
        };

        /**
         * Evaluates the condition {n} number of times with some delay between the attempts.
         * If evaluation result is truthy then returned promise is resolved.
         * @param {function} condition
         * @param {object} [options]
         * @param {object} [options.attempts]
         * @param {object} [options.delay]
         * @returns {Promise}
         */
        self.waitUntil = function (condition, options) {
            options = _.extend({ attempts: 100, delay: 10 }, options);

            return new Promise(function(resolve) {
                (function checkCondition() {
                    if (condition()) {
                        resolve();
                    } else if (--options.attempts > 0) {
                        _.delay(checkCondition, options.delay);
                    }
                })();
            });
        };

        self.toJQueryPromise = function(promise) {
            var deferred = $.Deferred();

            promise.then(function(result) {
                deferred.resolve(result);
            }, function(error) {
                deferred.reject(error);
            });

            return deferred;
        };

        self.scrollToTop = function (options) {
            var element;

            options = options || {};
            element = $(options.element || 'body');

            // Do not scroll if not really needed to allow immediate manual scrolling by a user
            if (element.scrollTop() >= 10) {
                $(options.element || 'html,body').animate({
                    scrollTop: 0
                }, 200);
            }
        };
    };

    return new Tools();
});

